import Dashboard from './Dashboard.jsx'

const Page = ({ toast }) => {
    return <Dashboard toast={toast} />
}

export default Page
